module.exports = __webpack_public_path__ + "img/6.c6140992.png";